/** Keep in sync with _pricing-breakpoints.scss ($pricing-compact-max-width). */
export const PRICING_COMPACT_MAX_WIDTH_PX = 960;

export const PRICING_COMPACT_MEDIA_QUERY =
  `(max-width: ${PRICING_COMPACT_MAX_WIDTH_PX}px)` as const;

/** Used by create-account-form (marketing opt-in by country). */
export const EUROPEAN_COUNTRIES_LIST = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GR',
  'HR',
  'HU',
  'IE',
  'IT',
  'LT',
  'LU',
  'LV',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SE',
  'SI',
  'SK',
] as const;

export const MARKETING_EMAIL_AUTO_OPT_IN_COUNTRIES_LIST = [
  'AU',
  'CA',
  'US',
] as const;
